/*
 * SonarQube
 * Copyright (C) 2009-2018 SonarSource SA
 * mailto:info AT sonarsource DOT com
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with this program; if not, write to the Free Software Foundation,
 * Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */
import * as React from 'react';
import * as classNames from 'classnames';
import Tooltip from './Tooltip';
import HelpIcon from '../icons-components/HelpIcon';
import * as theme from '../../app/theme';
import './HelpTooltip.css';

interface Props {
  className?: string;
  children?: React.ReactNode;
  onShow?: () => void;
  overlay: React.ReactNode;
  tagName?: string;
}

export default function HelpTooltip(props: Props) {
  const { children = <HelpIcon fill={theme.gray71} size={12} />, tagName = 'div' } = props;

  return React.createElement(
    tagName,
    { className: classNames('help-tooltip', props.className) },
    <Tooltip mouseLeaveDelay={0.25} onShow={props.onShow} overlay={props.overlay}>
      <span className="display-inline-flex-center">{children}</span>
    </Tooltip>
  );
}
